import Vue from "vue";
Vue.filter("prettyBytes", function (num) {
  // jacked from: https://github.com/sindresorhus/pretty-bytes
  if (typeof num !== "number" || isNaN(num)) {
    throw new TypeError("Expected a number");
  }

  var exponent;
  var unit;
  var neg = num < 0;
  var units = ["B", "kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  if (neg) {
    num = -num;
  }

  if (num < 1) {
    return (neg ? "-" : "") + num + " B";
  }

  exponent = Math.min(
    Math.floor(Math.log(num) / Math.log(1000)),
    units.length - 1
  );
  num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
  unit = units[exponent];

  return (neg ? "-" : "") + num + " " + unit;
});

Vue.filter("toCurrency", function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2
  });
  return formatter.format(value);
});

Vue.filter("tofloat", function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat("de-DE", {
    style: "percent",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  return formatter.format(value / 100);
});
Vue.filter("cleanasci", function (value) {

  return value.replace('&#40;', '(').replace('&#41;', ')')
});
Vue.filter("convertHex", function (color) {
  color = color.replace('#', '')
  let r = parseInt(color.substring(0, 2), 16)
  let g = parseInt(color.substring(2, 4), 16)
  let b = parseInt(color.substring(4, 6), 16)
  let result = 'rgba(' + r + ',' + g + ',' + b + ',' + 80 / 100 + ')'
  return result;
});
Vue.filter("replaceNbsp", function (string) {
  if (typeof string !== "string") {
    return string;
  }
  var result = "";
  result = string.replace(/\[nbsp\]/g, "&nbsp;");
  return result;
});

Vue.filter("replaceAmp", function (string) {
  if (typeof string !== "string") {
    return string;
  }
  var result = "";
  result = string.replace(/\[&\]/g, "&amp;");
  return result;
});

Vue.filter("replaceParenthesisLeft", function (string) {
  if (typeof string !== "string") {
    return string;
  }
  var result = "";
  result = string.replace(/\&#40;/g, "(");
  return result;
});
Vue.filter("replaceParenthesisRight", function (string) {
  if (typeof string !== "string") {
    return string;
  }
  var result = "";
  result = string.replace(/\&#41;/g, ")");
  return result;
});

Vue.filter("nl2br", function (string) {
  if (typeof string !== "string") {
    return string;
  }
  var breakTag = '<br>';
  return (string + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
});

Vue.filter("decToPercentage", function (value) {
  value = parseFloat(value.replace('%', ''));
  // value = value * 100;
  value = Math.round(value * 100);
  return value + '%';
});